import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import NoticeHelper from 'helpers/notice'
import {
  API_URL_SITE_LIST,
  API_URL_LOCUS_LIST,
  API_URL_LOCUS_TABLE,
  API_URL_LOCUS_ITEM,
  API_URL_LOCUS_FROM_SITE,
} from 'constants/index'
import * as ApiRouter from 'constants/apiRouting'
import { SHOW_NOTICE } from '../notice'
import {
  LOCUS_FETCH_LIST,
  LOCUS_FETCH_TABLE_DATA,
  LOCUS_SET_TABLE_DATA,
  LOCUS_FETCH_FORM_DATA,
  LOCUS_CHANGE,
  LOCUS_DISPLAY_TABLE,
  LOCUS_DISPLAY_FORM,
  LOCUS_DELETE,
  LOCUS_FROM_SITE,
  LOCUS_FROM_SITE_SUCCESS,
  LOCUS_FROM_SITE_FAILURE,
  FETCH_LOCUS_TREE,
  SUCCESS_LOCUS_TREE,
  FAILURE_LOCUS_TREE,
  LOCUS_FETCH_LIST_SUCCESS,
  LOCUS_FETCH_LIST_FAILURE,
} from './reducer'

function* locusFetchList(action) {
  try {
    const dataList = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_LOCUS_LIST}${UrlHelper.getPsfsQuery(action.payload)}`,
    })

    if (!dataList.hasOwnProperty('error')) {
      yield put({
        type: LOCUS_FETCH_LIST_SUCCESS,
      })
    } else {
      yield put({ type: LOCUS_FETCH_LIST_FAILURE })
    }

    yield put({ type: LOCUS_DISPLAY_TABLE, listData: dataList })
  } catch (error) {
    console.log('LOCUS SAGA ERROR', error)
  }
}

function* locusFetchTableData(action) {
  try {
    const data = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_LOCUS_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    yield put({
      type: LOCUS_SET_TABLE_DATA,
      tableData: data,
    })
  } catch (error) {
    console.log('LICENSEE INTERFACE ERROR', error)
  }
}

function* locusFetchFormData(action) {
  try {
    const { entityId } = action.payload
    const formData = {
      sites: [],
      locus: null,
    }

    formData.sites = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: API_URL_SITE_LIST,
    })

    if (entityId) {
      formData.locus = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.create(API_URL_LOCUS_ITEM, { id: entityId }),
      })
    }

    yield put({
      type: LOCUS_DISPLAY_FORM,
      formData,
    })
  } catch (error) {
    console.log('LOCUS SAGA ERROR', error)
  }
}

function* locusChange(action) {
  try {
    const { entityId, values } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: !entityId ? 'POST' : 'PUT',
      partUrl: !entityId
        ? API_URL_LOCUS_LIST
        : UrlHelper.create(API_URL_LOCUS_ITEM, { id: entityId }),
      data: values,
    })

    if (response.error) {
      return yield call(action.promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Locus ${entityId === 0 ? 'create' : 'change'} successful`,
      ),
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    throw new Error(`UNKNOW LOCUS CHANGE ERROR. DATA: ${error}`)
  }
}

function* locusDelete(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'DELETE',
      partUrl: UrlHelper.create(API_URL_LOCUS_ITEM, {
        id: action.payload.entityId,
      }),
    })

    if (response === 204) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Locus delete successful'),
      })

      return yield locusFetchTableData(action)
    }
  } catch (error) {
    console.log('LOCUS INTERFACE ERROR', error)
  }
}

function* locusFromSite(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'GET',
      partUrl: UrlHelper.create(API_URL_LOCUS_FROM_SITE, {
        id: action.payload,
      }),
    })

    if (!response || !response.error) {
      yield put({ type: LOCUS_FROM_SITE_SUCCESS, payload: response })
    } else {
      yield put({ type: LOCUS_FROM_SITE_FAILURE, error: response.errors })
    }
  } catch (error) {
    console.log('LOCUS INTERFACE ERROR', error)
  }
}

function* fetchLocusTree({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_TREE}${UrlHelper.getPsfsQuery(payload)}`,
    })

    if (response && !response.error) {
      yield put({ type: SUCCESS_LOCUS_TREE, payload: response })
    } else {
      yield put({ type: FAILURE_LOCUS_TREE, payload: response.error })
    }
  } catch (error) {
    console.log('FETCH LOCUS TREE FAILURE ', error)
  }
}

function* locusSaga() {
  yield takeLatest(LOCUS_FETCH_LIST, locusFetchList)
  yield takeLatest(LOCUS_FETCH_TABLE_DATA, locusFetchTableData)
  yield takeLatest(LOCUS_FETCH_FORM_DATA, locusFetchFormData)
  yield takeLatest(LOCUS_CHANGE, locusChange)
  yield takeLatest(LOCUS_DELETE, locusDelete)
  yield takeLatest(LOCUS_FROM_SITE, locusFromSite)
  yield takeLatest(FETCH_LOCUS_TREE, fetchLocusTree)
}

export default locusSaga
